"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _GridContainer = _interopRequireDefault(require("../../components/Grid/GridContainer/GridContainer"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _Quote = _interopRequireDefault(require("../../components/Quote/Quote"));
var _Callout = _interopRequireDefault(require("../../elements/Callout/Callout"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _CalloutQuote = _interopRequireDefault(require("../../elements/CalloutQuote/CalloutQuote"));
var _HorizontalDivider = _interopRequireDefault(require("../../elements/horizontal-divider/Horizontal-Divider"));
var _excluded = ["className", "children"],
  _excluded2 = ["headingCopy", "subheadingCopy", "testimonyTexts"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledLayoutContainer = (0, _styledComponents.default)(_GridContainer.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: 50px; \n  padding-left: 10px !important; \n  padding-right: 10px !important;\n  overflow: hidden;\n"])));
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  padding-bottom: 50px; \n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h3: true,
    white: true,
    special: true,
    className: className
  }, " ", children, " ");
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var ProofCarousel = (0, _styledComponents.default)(function (_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_nukaCarousel.default, {
    defaultControlsConfig: {
      nextButtonText: '>',
      prevButtonText: '<'
    },
    slidesToShow: 1,
    cellAlign: 'center',
    framePadding: '20px 20px',
    className: className,
    cellSpacing: 100,
    adaptiveHeight: true
  }, children);
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var SocialProof = function SocialProof(_ref4) {
  var headingCopy = _ref4.headingCopy,
    subheadingCopy = _ref4.subheadingCopy,
    testimonyTexts = _ref4.testimonyTexts,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledLayoutContainer, Object.assign({
    justifyContent: "flex-start"
  }, props), _react.default.createElement(StyledSectionHeading, Object.assign({
    xs: 12
  }, props), headingCopy), _react.default.createElement(ProofCarousel, null, testimonyTexts.map(function (testimony) {
    return _react.default.createElement(_CalloutQuote.default, {
      text: testimony.text,
      caption: testimony.attribution
    }, "  ");
  })), _react.default.createElement(_HorizontalDivider.default, null)));
};
var _default = SocialProof;
exports.default = _default;